import React, { Fragment } from 'react';
import './styles.css';
import {
	PageLayout,
	BupSpinner,
	ResourceElement,
	ErrorMessage
} from '@BUP/components';
import { useResources } from '@BUP/hooks';
import { Row, Col } from 'antd';

const ResourcesPage = () => {
	const { isLoading, data, error } = useResources();

	if (error) return <ErrorMessage />

	return (
		<PageLayout pageName="Recursos">
			<div className="resources-page-container">
				{
					isLoading ?
						(<BupSpinner size="large" />) :
						data && data.length ?
							(
								<Fragment>
									<div className="title-wrapper">
										<h1>Selecciona el área que quieres trabajar:</h1>
									</div>
									<Row className="select-resource-wrapper" gutter={[20, 30]}>
										{
											data.map((resource, idx) => (
												<Col 
													xs={24} 
													md={12} 
													xl={8} 
													className="element-wrapper"
													key={`resource-${idx}`}
												>
													<ResourceElement
														resource={resource}
													/>
												</Col>
											))
										}
									</Row>
								</Fragment>
							) :
							(
								<div className="empty-resources">
									<h1>No existen recursos</h1>
								</div>
							)
				}
			</div>
		</PageLayout>
	);
};

export default ResourcesPage;
